import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withWidth from '@material-ui/core/withWidth';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import Tooltip from '@material-ui/core/Tooltip';
import DialogContentText from '@material-ui/core/DialogContentText';

import getProfileFetch from '../actions/profile_actions';

export class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showProfile: false,
            user: this.props.profile,
            tempUser: {},
            value: 0, // for the profile tab
            showPasswordChange: false,
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
            invalidPasswords: false,
            notOldPassword: false, 
            newPasswordError: "New Passwords Do Not Match", // "New Password Error",
            passwordSubmitted: false
        };
    }

    preventTab = (e) => {
        e = e || window.event;
        if (e.keyCode === 9) { // If tab key is pressed
            e.preventDefault() // Stop event from its action
        }
    }

    handleOpen = () => {
        this.setState({ showProfile: true });
        this.setState({ tempUser: { ...this.state.user } });
        console.log("opening...");
        console.log(this.state.tempUser);
        console.log(this.props.profile);
    };

    // TODO: tab key press does not call handleClose() but somehow closes drawer
    handleClose = (event) => {
        console.log("closing edit profile");
        // event.preventDefault();
        /*if (event.type === 'keydown' && event.key === 'Tab') {
          console.log("pressed tab");
          return;
        }*/
        /*
        this.setState({ showProfile: false }, () => {
            this.closeMainMenuParent();
        });
        */
        this.closeMainMenuParent();
    };

    handleCancelEditProfile = () => {
        this.setState({
            showProfile: false,
        }, () => {
            this.closeMainMenuParent();
        });
    };

    handleSaveEditProfile = () => {
        this.setState({
            showProfile: false,
        }, () => {
            console.log("updated user profile", this.state.tempUser);
            this.props.updateProfile(this.state.tempUser);
            this.closeMainMenuParent();
        });
    };

    handleChange = property => event => {
        let newTempUser = this.state.tempUser;
        newTempUser[property] = event.target.value;
        this.setState({ tempUser: newTempUser }, () => {
        });
    };
    ///
    stopPropagationForTab = (event) => {
        if (event.key === "Tab") {
            event.stopPropagation();
        }
    };
    showPasswordChange = () => {
        this.setState({ showPasswordChange: true });
    };
    handleOldPasswordInput = event => {
        this.setState({ notOldPassword: false });
        this.setState({ oldPassword: event.target.value });
    };
    handleNewPasswordInput = event => {
        this.setState({ newPassword: event.target.value });
        let regex = /^(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,16}$/;
        let newIsValidPassword = regex.test(event.target.value);
        if (newIsValidPassword) {
            if (event.target.value !== this.state.confirmPassword && this.state.confirmPassword.length > 0) {
                this.setState({ invalidPasswords: true });
                this.setState({ newPasswordError: "New Passwords Do Not Match" });
            } else {
                this.setState({ invalidPasswords: false });
            }
        } else {
            this.setState({ invalidPasswords: true });
            this.setState({ newPasswordError: "Invalid Password" });
        }
    };
    handleConfirmPasswordInput = event => {
        if (event.target.value.length === 0) {
            this.setState({ confirmPassword: "" });
        } else {
            this.setState({ confirmPassword: event.target.value });
            if (event.target.value !== this.state.newPassword) {
                this.setState({ invalidPasswords: true });
                this.setState({ newPasswordError: "New Passwords Do Not Match" });
            } else {
                let regex = /^(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,16}$/;
                let newIsValidPassword = regex.test(event.target.value);
                if (newIsValidPassword) {
                    this.setState({ invalidPasswords: false });
                } else {
                    this.setState({ invalidPasswords: true });
                    this.setState({ newPasswordError: "Invalid Password" });
                }
            }
        }
    };
    handleSaveNewPassword = () => {
        this.setState({
            showProfile: false,
            showPasswordChange: false,
        }, () => {
            console.log("updated user profile", this.state.tempUser);
        });
    };
    verifyOldPassword = (hashedPassword, oldPassword) => {
        const token = localStorage.token;
        return fetch("/api/user/VerifyPassword", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': `Bearer ${token}`,
                credentials: 'include'
            },
            body: JSON.stringify({ hashedPassword, oldPassword }),
        })
        .then(resp => resp.text())
        .then(data => data)
        .catch(err => {
            console.log(err);
        });
    };
    changePassword = () => {
        console.log(`New Password: ${this.state.newPassword}`);
        let newTempUser = this.state.tempUser;
        newTempUser["newPassword"] = this.state.newPassword;
        this.setState({ tempUser: newTempUser }, () => {
            console.log("updated user profile", this.state.tempUser);
            this.props.updateProfile(this.state.tempUser);
            this.setState({ showPasswordChange: false });
            this.setState({ passwordSubmitted: true });
        });
    };
    handleChangePasswordSubmit = async event => {
        if (event !== undefined) event.preventDefault();
        let oldPasswordsMatch = JSON.parse(await this.verifyOldPassword(this.state.user.password, this.state.oldPassword)); 
        if (oldPasswordsMatch) {
            this.setState({ notOldPassword: false });
            if (this.state.newPassword === this.state.confirmPassword) {
                this.setState({ invalidPasswords: false });
                if (this.state.newPassword !== this.state.oldPassword) {
                    let regex = /^(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,16}$/;
                    let newIsValidPassword = regex.test(this.state.newPassword);
                    if (newIsValidPassword) {
                        this.setState({ invalidPasswords: false });
                        this.changePassword();
                    } else {
                        this.setState({ invalidPasswords: true });
                        this.setState({ newPasswordError: "Invalid Password" });
                    }
                } else {
                    this.setState({ invalidPasswords: true });
                    this.setState({ newPasswordError: "New Password Should Not Equal Old Password" });
                }
            } else {
                this.setState({ invalidPasswords: true });
                this.setState({ newPasswordError: "New Passwords Do Not Match" });
            }
        } else {
            this.setState({ notOldPassword: true });
        }
    };
    submitPasswords = event => {
        if (event.keyCode == 13) {
            console.log("Submiting with Enter...");
            this.handleChangePasswordSubmit(event);
        }
    }
    ///       

  handleTabChange = (event, value) => {
    this.setState({ value });
  };

  closeMainMenuParent = () => {
    this.props.callbackFromParent();
  };

  render() {
    const { value } = this.state;
    const { width } = this.props;

    let responsiveEditProfile, responsiveChangePassword, passwordSubmittedPopup; 

    if (width !== "xs") {
      responsiveEditProfile =
        <div>
          <Dialog
            open={this.state.showProfile}
            close={this.handleClose}
            aria-labelledby="form-dialog-title"
            onKeyDown={this.stopPropagationForTab}
          >
            <Paper square>
              <Tabs
                value={this.state.value}
                indicatorColor="primary"
                textColor="primary"
                onChange={this.handleTabChange}
                centered
              >
                <Tab label="Profile" />
                <Tab label="Schedule" />
              </Tabs>
              {value === 0 &&
                <div>
                  <DialogTitle id="form-dialog-title">
                    Edit Your Profile
                </DialogTitle>
                  <DialogContent>
                    <TextField
                      margin="normal"
                      id="name"
                      label="First Name"
                      type="name"
                      value={this.state.tempUser.firstName}
                      onChange={this.handleChange('firstName')}
                      fullWidth
                      inputProps={{ tabIndex: "1" }}
                    />
                    <TextField
                      margin="normal"
                      id="name"
                      label="Last Name"
                      type="name"
                      value={this.state.tempUser.lastName}
                      onChange={this.handleChange('lastName')}
                      fullWidth
                      inputProps={{ tabIndex: "2" }}
                    />
                    <TextField
                      margin="normal"
                      id="address"
                      label="Address"
                      type="name"
                      value={this.state.tempUser.address}
                      onChange={this.handleChange('address')}
                      fullWidth
                      inputProps={{ tabIndex: "3" }}
                    />

                    <Grid container spacing={24}>
                      <Grid item xs={4}>
                        <TextField
                          margin="normal"
                          id="city"
                          label="City"
                          type="name"
                          value={this.state.tempUser.city}
                          onChange={this.handleChange('city')}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextField
                          margin="normal"
                          id="state"
                          label="State"
                          type="name"
                          value={this.state.tempUser.state}
                          onChange={this.handleChange('state')}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextField
                          margin="normal"
                          id="zipCode"
                          label="ZipCode"
                          type="name"
                          value={this.state.tempUser.zipCode}
                          onChange={this.handleChange('zipCode')}
                          fullWidth
                        />
                      </Grid>
                    </Grid>

                    <TextField
                      margin="normal"
                      id="work phone"
                      label="Work Phone"
                      type="phone"
                      value={this.state.tempUser.workPhone}
                      onChange={this.handleChange('workPhone')}
                      fullWidth
                    />
                    <TextField
                      margin="normal"
                      id="cell phone"
                      label="Cell Phone"
                      type="phone"
                      value={this.state.tempUser.cellPhone}
                      onChange={this.handleChange('cellPhone')}
                      fullWidth
                    />
                    <TextField
                      margin="normal"
                      id="home phone"
                      label="Home Phone"
                      type="phone"
                      value={this.state.tempUser.homePhone}
                      onChange={this.handleChange('homePhone')}
                      fullWidth
                    />
                    <TextField
                      margin="normal"
                      id="name"
                      label="Email Address"
                      type="email"
                      autoComplete="email"
                      value={this.state.tempUser.email}
                      onChange={this.handleChange('email')}
                      fullWidth
                    />
                     <TextField
                       margin="normal"
                       id="password"
                       label="Password"
                       type="password"
                       autoComplete="password"
                       value={this.state.tempUser.password}
                       InputProps={{ endAdornment: <Button color="primary" onClick={this.showPasswordChange}>Change</Button> }}
                       fullWidth
                      />
                    <TextField
                      margin="normal"
                      id="ext"
                      label="Extension"
                      type="string"
                      value={this.state.tempUser.extension}
                      onChange={this.handleChange('extension')}
                      fullWidth
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleCancelEditProfile} color="secondary">
                      Cancel
                  </Button>
                    <Button onClick={this.handleSaveEditProfile} color="primary">
                      Save
                    </Button>
                  </DialogActions>
                </div>
              }
              {value === 1 &&
              <div>
              <DialogTitle id="form-dialog-title">
                Edit Your Schedule
              </DialogTitle>
              <DialogContent>
                  <TextField
                      margin="normal"
                      id="schedule"
                      label="Monday"
                      type="schedule"
                      value={this.state.tempUser.monday}
                      onChange={this.handleChange('monday')}
                      fullWidth
                  />
                  <TextField
                      margin="normal"
                      id="schedule"
                      label="Tuesday"
                      type="schedule"
                      value={this.state.tempUser.tuesday}
                      onChange={this.handleChange('tuesday')}
                      fullWidth
                  />
                  <TextField
                      margin="normal"
                      id="schedule"
                      label="Wednesday"
                      type="schedule"
                      value={this.state.tempUser.wednesday}
                      onChange={this.handleChange('wednesday')}
                      fullWidth
                  />
                  <TextField
                      margin="normal"
                      id="schedule"
                      label="Thursday"
                      type="schedule"
                      value={this.state.tempUser.thursday}
                      onChange={this.handleChange('thursday')}
                      fullWidth
                  />
                  <TextField
                      margin="normal"
                      id="schedule"
                      label="Friday"
                      type="schedule"
                      value={this.state.tempUser.friday}
                      onChange={this.handleChange('friday')}
                      fullWidth
                  />
                  <TextField
                      margin="normal"
                      id="schedule"
                      label="Saturday"
                      type="schedule"
                      value={this.state.tempUser.saturday}
                      onChange={this.handleChange('saturday')}
                      fullWidth
                  />
                  <TextField
                      margin="normal"
                      id="schedule"
                      label="Sunday"
                      type="schedule"
                      value={this.state.tempUser.sunday}
                      onChange={this.handleChange('sunday')}
                      fullWidth
                  />
              </DialogContent>
              </div>
              }
            </Paper>
          </Dialog>
            </div>;
        responsiveChangePassword =
            <div>
            <Dialog
                open={this.state.showPasswordChange}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title"
                onKeyDown={this.stopPropagationForTab}
            >
            <Paper square>
            <div>
                <DialogTitle id="form-dialog-title">
                    Change Password
             </DialogTitle>
               <DialogContent>
                 <form onSubmit={this.handleChangePasswordSubmit} onKeyDown={this.submitPasswords}>
                    <TextField
                        margin="normal"
                        id="old_password"
                        label="Old Password"
                        // type="password"
                        // required={true}
                        FormHelperTextProps={{ style: { position: "absolute", bottom: "-14.5px" } }}
                        autoComplete="off"
                        fullWidth
                        onChange={this.handleOldPasswordInput}  
                        inputProps={{ tabIndex: "1" }}
                        error={this.state.notOldPassword}
                        helperText={this.state.notOldPassword ? "Incorrect Password" : ""}
                          />
                    <TextField
                        margin="normal"
                        id="new_password"
                        label="New Password"
                        // type="password"
                        // required={true}
                        FormHelperTextProps={{ style: { position: "absolute", bottom: "-14.5px" } }}
                        autoComplete="off"
                        error={this.state.invalidPasswords}
                        fullWidth
                        onChange={this.handleNewPasswordInput}
                        inputProps={{ tabIndex: "2" }}
                    />
                    <ul style={{ paddingTop: '10px', fontSize: '10px', color: 'grey' }}>
                        <li style={{ paddingBottom: '10px' }}>The new password can not equal the old password.</li>
                        <li>New passwords must have a minimum of 8 characters, maximum of 16 characters, one capital letter, and one number.</li>
                    </ul>
                    <TextField
                        margin="normal"
                        id="confirm_password"
                        label="Confirm New Password"
                        // type="password"
                        // required={true}
                        FormHelperTextProps={{ style: { position: "absolute", bottom: "-14.5px" } }}
                        autoComplete="off"
                        onChange={this.handleConfirmPasswordInput}
                        error={this.state.invalidPasswords}
                        helperText={this.state.invalidPasswords ? this.state.newPasswordError : "" }
                        fullWidth
                        inputProps={{ tabIndex: "3" }}
                      />
                </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancelEditProfile} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={this.handleChangePasswordSubmit} color="primary">
                        Save
                    </Button>
                </DialogActions>
              </div>
            </Paper>
          </Dialog>
            </div>;
        passwordSubmittedPopup =
        <div>
            <Dialog
                open={this.state.passwordSubmitted}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ margin: "5px !important" }}
        >
           <Paper square>
            <div>
                <DialogTitle id="alert-dialog-title">
                    <span style={{ color: "green" }}>Success</span>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        You have successfully changed your password.
                   </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} style={{ color: "green" }}>Ok</Button>
                </DialogActions>
            </div>
            </Paper>
            </Dialog>
        </div>;
    } else {
        responsiveEditProfile =
            <div
                style={{ flexGrow: '1' }}
                role="presentation"
            >
                <Drawer open={this.state.showProfile} onClose={this.handleClose} onKeyDown={this.stopPropagationForTab}>
                    <div
                        style={{ width: '190px', flexGrow: '1', marginBottom: '0px', marginLeft: '5px', marginRight: '15px' }}
                        role="presentation"
                    >
                        <Grid container spacing={0}>
                            <Grid item md={6}>
                                <h4 style={{ marginTop: '8px', marginBottom: '0px' }}><b>Edit Your Profile</b></h4>
                            </Grid>
                            <Grid item xs={3}>
                                <CloseIcon style={{ marginTop: '5px', marginBottom: '0px', marginLeft: '35px' }} onClick={this.handleClose} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={4} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Username</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "1" }}
                                    disabled
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.username}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '5px' }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={4} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>First Name</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "1" }}
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.firstName}
                                    onChange={this.handleChange('firstName')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '5px' }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={4} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Last Name</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "2" }}
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.lastName}
                                    onChange={this.handleChange('lastName')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '5px' }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Address</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "3" }}
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.address}
                                    onChange={this.handleChange('address')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>City</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "4" }}
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.city}
                                    onChange={this.handleChange('city')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>State</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "5" }}
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.state}
                                    onChange={this.handleChange('state')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>ZipCode</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "6" }}
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.zipCode}
                                    onChange={this.handleChange('zipCode')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={4} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Work Phone</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "7" }}
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.workPhone}
                                    onChange={this.handleChange('workPhone')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '5px' }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={0}>
                            <Grid item xs={4} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Cell Phone</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "8" }}
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.cellPhone}
                                    onChange={this.handleChange('cellPhone')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '5px' }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={0}>
                            <Grid item xs={4} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Home Phone</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "9" }}
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.homePhone}
                                    onChange={this.handleChange('homePhone')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '5px' }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Email</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "10" }}
                                    margin="normal"
                                    id="name"
                                    type="name"
                                    value={this.state.tempUser.email}
                                    onChange={this.handleChange('email')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Password</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="normal"
                                    id="password"
                                    name="password"
                                    type="password"
                                    value={this.state.tempUser.password}
                                    fullWidth
                                    InputProps={{ endAdornment: <Button color="primary" onClick={this.showPasswordChange}>Change</Button> }}
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                    />
                            </Grid>
                        </Grid>
                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Extension</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "11" }}
                                    margin="normal"
                                    id="name"
                                    type="string"
                                    value={this.state.tempUser.extension}
                                    onChange={this.handleChange('extension')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                //spellCheck="false"
                                />
                            </Grid>
                        </Grid>

                        <h4 style={{ marginTop: '30px', marginBottom: '0px' }} ><b>Edit Your Schedule</b></h4>

                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Monday</span>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    inputProps={{ tabIndex: "12" }}
                                    margin="normal"
                                    id="schedule"
                                    //label="Monday"
                                    type="schedule"
                                    value={this.state.tempUser.monday}
                                    onChange={this.handleChange('monday')}
                                    fullWidth
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                />
                            </Grid>

                            <Grid container spacing={0}>
                                <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                    <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Tuesday</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        inputProps={{ tabIndex: "13" }}
                                        margin="normal"
                                        id="schedule"
                                        //label="Tuesday"
                                        type="schedule"
                                        value={this.state.tempUser.tuesday}
                                        onChange={this.handleChange('tuesday')}
                                        fullWidth
                                        style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={0}>
                                <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                    <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Wednesday</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        inputProps={{ tabIndex: "14" }}
                                        margin="normal"
                                        id="schedule"
                                        //label="Wednesday"
                                        type="schedule"
                                        value={this.state.tempUser.wednesday}
                                        onChange={this.handleChange('wednesday')}
                                        fullWidth
                                        style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={0}>
                                <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                    <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Thursday</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        inputProps={{ tabIndex: "15" }}
                                        margin="normal"
                                        id="schedule"
                                        //label="Thursday"
                                        type="schedule"
                                        value={this.state.tempUser.thursday}
                                        onChange={this.handleChange('thursday')}
                                        fullWidth
                                        style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={0}>
                                <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                    <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Friday</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        inputProps={{ tabIndex: "16" }}
                                        margin="normal"
                                        id="schedule"
                                        //label="Friday"
                                        type="schedule"
                                        value={this.state.tempUser.friday}
                                        onChange={this.handleChange('friday')}
                                        fullWidth
                                        style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={0}>
                                <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                    <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Saturday</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        inputProps={{ tabIndex: "17" }}
                                        margin="normal"
                                        id="schedule"
                                        //label="Saturday"
                                        type="schedule"
                                        value={this.state.tempUser.saturday}
                                        onChange={this.handleChange('saturday')}
                                        fullWidth
                                        style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={0}>
                                <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                    <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Sunday</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        inputProps={{ tabIndex: "18" }}
                                        margin="normal"
                                        id="schedule"
                                        //label="Sunday"
                                        type="schedule"
                                        value={this.state.tempUser.sunday}
                                        onChange={this.handleChange('sunday')}
                                        fullWidth
                                        style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <div style={{ display: 'block', padding: '20px', height: '60px', width: '100%' }} /> {/*phantom div to make buttons sticky footer */}
                        <div style={{ position: 'sticky', left: '0', bottom: '0', height: '50px', width: '100%', backgroundColor: '#3f51b5' }}>
                            <Grid container spacing={0} style={{ paddingBottom: '0px' }}>
                                <Grid item xs={6} style={{ paddingLeft: '30px' }}>
                                    <Tooltip
                                        placement="top"
                                        enterDelay={500}
                                        title={
                                            <React.Fragment>
                                                <h6>
                                                    Cancel
                      </h6>
                                            </React.Fragment>
                                        }
                                    >
                                        <IconButton onClick={this.handleCancelEditProfile} style={{ color: 'white' }}>
                                            <CancelIcon style={{ fontSize: '25px' }} />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={6} style={{ paddingLeft: '30px' }}>
                                    <Tooltip
                                        placement="top"
                                        enterDelay={500}
                                        title={
                                            <React.Fragment>
                                                <h6>
                                                    Save
                      </h6>
                                            </React.Fragment>
                                        }
                                    >
                                        <IconButton onClick={this.handleSaveEditProfile} style={{ color: 'white', alignItems: 'center', alignContent: 'center' }}>
                                            <SaveIcon style={{ fontSize: '25px' }} />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Drawer>
            </div>;
        responsiveChangePassword =    
            <div
                style={{ flexGrow: '1' }}
                // role="presentation"
            >
                <Drawer
                    open={this.state.showPasswordChange}
                    onClose={this.handleClose}
                    onKeyDown={this.stopPropagationForTab}>
                    <div
                        style={{ width: '190px', flexGrow: '1', marginBottom: '0px', marginLeft: '5px', marginRight: '15px' }}
                        role="presentation"
                    >
                    <Grid container spacing={0}>
                        <Grid item md={7}>
                            <h4 style={{ marginTop: '8px', marginBottom: '0px', padding: '0px' }}><b>Change Password</b></h4>
                        </Grid>
                        <Grid item xs={2}>
                            <CloseIcon style={{ marginTop: '5px', marginBottom: '0px', marginLeft: '18px', cursor: 'pointer' }} onClick={this.handleClose} />
                        </Grid>
                    </Grid>
                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Old Password</span>
                            </Grid>
                            <Grid item xs={6}>
                            <TextField
                                margin="normal"
                                id="old_password"
                                // label="Old Password"
                                // type="password"
                                // required={true}
                                value={this.state.oldPassword}
                                FormHelperTextProps={{ style: { position: "absolute", bottom: "-14.5px" } }}
                                autoComplete="off"
                                fullWidth
                                onChange={this.handleOldPasswordInput}
                                inputProps={{ tabIndex: "1" }}
                                style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                error={this.state.notOldPassword}
                                helperText={this.state.notOldPassword ? "Incorrect Password" : ""}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>New Password</span>
                            </Grid>
                        <Grid item xs={6}>
                                <TextField
                                    margin="normal"
                                    id="new_password"
                                    // label="New Password"
                                    // type="password"
                                    // required={true}
                                    value={this.state.newPassword}
                                    autoComplete="off"
                                    error={this.state.invalidPasswords}
                                    fullWidth
                                    onChange={this.handleNewPasswordInput}
                                    // inputProps={{ tabIndex: "2" }}
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                            />
                            </Grid>
                    </Grid>
       
                    <Grid container spacing={0}>
                        <Grid item xs={11}>
                            <ul style={{ padding: '16px 0 0 20px', fontSize: '10px', color: 'grey', width: '100%' }}>
                                <li style={{ paddingBottom: '10px' }}>The new password can not equal the old password.</li>
                                <li>New passwords must have a minimum of 8 characters, maximum of 16 characters, one capital letter, and one number.</li>
                            </ul>
                        </Grid>
                    </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={3} style={{ paddingTop: '16px' }}>
                                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Confirm Password</span>
                            </Grid>
                        <Grid item xs={6}>
                                <TextField
                                    margin="normal"
                                    id="confirm_password"
                                    // label="Confirm New Password"
                                    // type="password"
                                    // required={true}
                                    value={this.state.confirmPassword}
                                    autoComplete="off"
                                    onChange={this.handleConfirmPasswordInput}
                                    error={this.state.invalidPasswords}
                                    helperText={this.state.invalidPasswords ? this.state.newPasswordError : ""}
                                    fullWidth
                                    // inputProps={{ tabIndex: "3" }}
                                    style={{ marginBottom: '0px', width: '120px', marginLeft: '20px' }}
                                />
                        </Grid>
                    </Grid>
          </div>
                <div>
                    <div style={{ display: 'block', padding: '20px', height: '60px', width: '100%' }} /> {/*phantom div to make buttons sticky footer */}
                    <div style={{ position: 'sticky', left: '0', bottom: '0', height: '50px', width: '100%', backgroundColor: '#3f51b5' }}>
                        <Grid container spacing={0} style={{ paddingBottom: '0px' }}>
                            <Grid item xs={6} style={{ paddingLeft: '30px' }}>
                                <Tooltip
                                    placement="top"
                                    enterDelay={500}
                                    title={
                                        <React.Fragment>
                                            <h6>
                                                Cancel
                      </h6>
                                        </React.Fragment>
                                    }
                                >
                                    <IconButton onClick={this.handleCancelEditProfile} style={{ color: 'white' }}>
                                        <CancelIcon style={{ fontSize: '25px' }} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={6} style={{ paddingLeft: '30px' }}>
                                <Tooltip
                                    placement="top"
                                    enterDelay={500}
                                    title={
                                        <React.Fragment>
                                            <h6>
                                                Save
                      </h6>
                                        </React.Fragment>
                                    }
                                >
                                    <IconButton onClick={this.handleChangePasswordSubmit} style={{ color: 'white', alignItems: 'center', alignContent: 'center' }}>
                                        <SaveIcon style={{ fontSize: '25px', color: 'white' }} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </div>
                </div>
          </Drawer>
            </div >;
        passwordSubmittedPopup =
            <div style={{ flexGrow: '1' }}>
            <Grid container spacing={0} style={{ paddingBottom: '0px', }}>
                <Dialog
                    open={this.state.passwordSubmitted}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    // PaperProps={{ sx: { position: 'absolute', top: '0px' } }}
                >
                <Paper square>
                <div style={{ flexGrow: '1', width: '100%' }}
                    // style={{ height: '100%', width: '190px', }}
                >
                  <DialogTitle id="alert-dialog-title">
                    <span style={{ color: "green" }}>Success</span>
                  </DialogTitle>
                  <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                          You have successfully changed your password.
                  </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleClose} style={{ color: "green" }}>Ok</Button>
                  </DialogActions>
                </div>
                </Paper>
                </Dialog>
        </Grid>
        </div>;
      }
      let displayedComponent; 
      if (this.state.showPasswordChange) {
          displayedComponent = responsiveChangePassword;
      } else if (this.state.passwordSubmitted) {
          displayedComponent = passwordSubmittedPopup;
      } else {
          displayedComponent = responsiveEditProfile;
      }
    return (
      <div>
        <MenuItem onClick={this.handleOpen} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> Edit Profile</MenuItem>
        { displayedComponent }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    members: state.members,
    profile: state.profile
  };
}

const mapDispatchToProps = dispatch => ({
    updateProfile: user => dispatch(getProfileFetch['UPDATE_PROFILE'](user))
})

Profile.propTypes = {
  width: PropTypes.string.isRequired,
};

// export default connect(mapStateToProps, mapDispatchToProps)(Profile);

// export default withWidth()(Profile);

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(Profile));


// WEBPACK FOOTER //
// ./src/components/Profile.js